export const RESERVATION_COLUMNS = {
  unitType: 'UNIT TYPE',
  reservationCode: 'RESERVATION CODE',
  moveInDate: 'EXPECTED MOVE IN DATE',
  reservationCreated: 'RESERVATION CREATED',
  actions: 'ACTIONS',
};

export const ACTION_BUTTON_LABEL = 'Move in';

export const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];
